export const styles = theme => ({
    backButton: {
        marginLeft: -20,
    },
    backgroundDiv: {
        height: '30vh',
        backgroundColor: '#212121',
        [theme.breakpoints.up('sm')]: {}
    },
    logoDiv: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    logoImage: {
        cursor: 'pointer',
        display: 'block',
        width: '160px',
        paddingTop: '30px',
        paddingBottom: '60px',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginLeft: 0,
            paddingTop: '50px',
            paddingBottom: '60px',
        },
    },
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: 20,
        marginRight: 20,
        marginTop: '-27vh',
        [theme.breakpoints.up('sm')]: {
            width: 400,
            marginTop: '-30vh',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: '15vh',
        marginBottom: theme.spacing.unit * 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '25px 20px 40px',
        [theme.breakpoints.up('sm')]: {
            paddingTop: '40px',
            paddingLeft: '30px',
            paddingRight: '30px',
        },
    },
    form: {},
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    registerButton: {
        marginTop: '20px',
    },
    signInText: {
        textAlign: 'center',
        alignSelf: 'center',
        [theme.breakpoints.up('md')]: {
            alignSelf: 'flex-start'
        }
    },
    checkContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '15px',
        '& .checkLabel': {
            fontSize: 12,
        },
    },
});
